import { api } from './api';

export interface AgentGroup {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  color?: string;
  agent_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateGroupRequest {
  name: string;
  description?: string;
  color?: string;
  agent_ids?: string[];
}

export interface UpdateGroupRequest {
  name?: string;
  description?: string;
  color?: string;
  agent_ids?: string[];
}

export const agentGroupService = {
  // List all groups for the organization
  async listGroups(): Promise<AgentGroup[]> {
    const response = await api.get<AgentGroup[]>('/agent-groups');
    return response.data;
  },

  // Get a single group by ID
  async getGroup(groupId: string): Promise<AgentGroup> {
    const response = await api.get<AgentGroup>(`/agent-groups/${groupId}`);
    return response.data;
  },

  // Create a new group
  async createGroup(data: CreateGroupRequest): Promise<AgentGroup> {
    const response = await api.post<AgentGroup>('/agent-groups', data);
    return response.data;
  },

  // Update a group
  async updateGroup(groupId: string, data: UpdateGroupRequest): Promise<AgentGroup> {
    const response = await api.put<AgentGroup>(`/agent-groups/${groupId}`, data);
    return response.data;
  },

  // Delete a group
  async deleteGroup(groupId: string): Promise<void> {
    await api.delete(`/agent-groups/${groupId}`);
  },

  // Get all agents in a group
  async getGroupAgents(groupId: string): Promise<any[]> {
    const response = await api.get(`/agent-groups/${groupId}/agents`);
    return response.data;
  },

  // Add an agent to a group
  async addAgentToGroup(groupId: string, agentId: string): Promise<AgentGroup> {
    const response = await api.post<AgentGroup>(`/agent-groups/${groupId}/agents/${agentId}`);
    return response.data;
  },

  // Remove an agent from a group
  async removeAgentFromGroup(groupId: string, agentId: string): Promise<AgentGroup> {
    const response = await api.delete<AgentGroup>(`/agent-groups/${groupId}/agents/${agentId}`);
    return response.data;
  },
};
